
import values from 'lodash/values';
import createSort from '../../../shared/table/create-sort.js';

export const tableInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'Id',
			direction: 'desc',
			className: 'id'
		},
		name: {
			index: 'name',
			title: 'Title/Date',
			direction: 'desc',
			className: 'title'
		},
		offer: {
			index: 'offer',
			title: 'Offer/Country',
			direction: 'desc',
			className: 'offer'
		},
		chain: {
			index: 'chain',
			title: 'Chain',
			className: 'chain'
		},
		affiliates: {
			index: 'affiliates',
			title: 'Affiliates',
			className: 'affiliates'
		},
		comments: {
			index: 'comments',
			title: 'Comments',
			className: 'comments'
		},
		campaign_counter: {
			index: 'campaign_counter',
			title: 'C-C/C-A',
			direction: 'desc',
			className: 'conversions'
		},
		actions: {
			title: 'Actions'
		}
	},
	sortByColumn: {
		index: 'date',
		direction: 'asc'
	},
	rowsNumber: 1000
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {

	const sort = createSort(namespace, stateNodeName, {
		type: configureSort.type,
		resolverSortFn: configureSort.resolverSortFn
	});

	// action types
	const SHOW_MORE_ROWS = `${namespace}/table-show-more-rows`;

	// initState
	const initialState = {
		...tableInitialState
	};

	// actions
	const actions = Object.assign({
		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		})
	}, sort.actions);

	// reducers
	const reducers = Object.assign({}, sort.reducers);

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];
			const mappedRows = rows.map(row => ({
				...row
			}));

			return {
				headers: values(table.columns),
				rows: mappedRows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/chaining/components/table/index.js